import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { DynamicQuestion } from "~app/inscription/store/cotisation-form/inscription.model";
import { LocalizedString } from '~app/shared/model/localized-string.model';
import { AbstractDynamicInput } from "../abstract-dynamic-input";

@Component({
    selector: 'odq-dynamic-select',
    templateUrl: './dynamic-select.component.html',
    styleUrls: ['./dynamic-select.component.scss'],
    standalone: false
})
export class DynamicSelectComponent extends AbstractDynamicInput implements OnInit {
  @Input()
  summary: boolean = false;

  @Input()
  questions: DynamicQuestion[] = [];

  @Input()
  label: string = '';

  @Input()
  formControls: Map<number, UntypedFormControl>;

  questionModel: any;

  constructor(translate: TranslateService, private cdr: ChangeDetectorRef) { super(translate) }

  ngOnInit(): void {
    //Initiate model with saved value 
    this.questions.forEach(question => {
      if (this.formControls.get(question.questionNumber)?.value === 'selected') {
        this.questionModel = question.questionNumber;
      }
    });

    this.cdr.detectChanges();
  }

  // Update form control values
  onModelChange() {
    this.questions.forEach(question => {
      const ctrl = this.formControls.get(question.questionNumber);
      ctrl.patchValue(this.questionModel === question.questionNumber ? "selected" : "");
    });
  }

  // Summary label
  getSummaryLabel(): LocalizedString {
    return this.questions.find(q => q.questionNumber === this.questionModel)?.summaryLabel;
  }
}